module.exports = __webpack_public_path__ + "assets/img/logo.8a6b70e2.png";